import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { LoginFailureModal } from './LoginFailureModal/LoginFailureModal';
export const GetOAuthLoginFailureTID = (parentTestId)=>getTestIds(parentTestId);
const PROVIDER_ACCOUNT_URLS = {
    qbo: 'https://accounts.intuit.com/app/account-manager/security',
    xero: 'https://login.xero.com/identity/user/profile'
};
const SUPPORT_MAIL_URL = 'mailto:support@sayanchor.com';
export const OAuthLoginFailure = (param)=>{
    let { provider, failure, dismissModal } = param;
    const { browser: { openNewTab } } = useIoContext();
    const { t: loginFailureTexts } = useLocaleKeys('auth.loginFailureModal');
    const { OAuthLoginFailureTestIds } = useMemo(()=>GetOAuthLoginFailureTID(), []);
    const emailUnverifiedMessage = ()=>{
        const providerLink = /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'login_failure_provider_account'
            },
            testId: OAuthLoginFailureTestIds.ProviderAccountLink(),
            onClick: ()=>openNewTab(PROVIDER_ACCOUNT_URLS[provider])
        });
        return loginFailureTexts.emailUnverified[provider]({
            providerLink
        });
    };
    const invalidEmailMessage = ()=>{
        const supportLink = /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'login_failure_contact_support'
            },
            testId: OAuthLoginFailureTestIds.SupportLink(),
            onClick: ()=>openNewTab(SUPPORT_MAIL_URL)
        });
        return loginFailureTexts.invalidEmail({
            supportLink
        });
    };
    return /*#__PURE__*/ _jsx(LoginFailureModal, {
        testId: OAuthLoginFailureTestIds.Root(),
        title: loginFailureTexts.title(),
        message: failure === 'email_unverified' ? emailUnverifiedMessage() : invalidEmailMessage(),
        dismissModal: dismissModal
    });
};
